import { SettingsResponse } from '@business/entities/settings';
import { SettingsConfig } from '@core/utils/config';
import { R } from '@core/utils/r';
const pluralize = require('pluralize');

export function gcLabel(name: string, setting: SettingsResponse | null = null, isPlural = false) {
  const settings = setting ? setting : SettingsConfig.get();
  if (settings) {
    const appLabels = settings.appLabels;
    const estimateText = settings.order?.estimateText || 'Estimate';
    const label = appLabels.filter(l => {
      return (
        l.name === name ||
        pluralize.plural(l.name) === name ||
        pluralize.singular(l.name) === name ||
        l.name === R.startCase(name) ||
        pluralize.plural(l.name) === R.startCase(name) ||
        pluralize.singular(l.name) === R.startCase(name)
      );
    });

    let labelValue = name;
    if (label && label?.length > 0) {
      labelValue = R.first(label)?.value || '';
    }

    labelValue = R.lowerCase(name) == 'estimate' ? estimateText : labelValue;

    if (R.upperCase(name) === name) {
      labelValue = R.upperCase(labelValue);
    } else if (R.lowerCase(name) === name) {
      labelValue = R.lowerCase(labelValue);
    } else if (R.startCase(name) === name) {
      labelValue = R.startCase(labelValue);
    }
    const labelBefore = labelValue;

    if (pluralize.isPlural(name)) {
      labelValue = pluralize.plural(labelValue);
    } else if (pluralize.isSingular(name)) {
      labelValue = pluralize.singular(labelValue);
    }

    if (name == 'Contact' && labelBefore == 'People' && labelValue == 'Person') {
      labelValue = labelBefore;
    }

    const resultValue = labelValue || name;
    return isPlural ? pluralize.plural(resultValue) : resultValue;
  } else {
    return isPlural ? pluralize.plural(name) : name;
  }
}

export function isGCLabelActive(name: string) {
  const settings = SettingsConfig.get();
  const appLabels = settings?.appLabels || [];
  const label = R.find(appLabels, l => l.name === name);
  if (label) {
    return label.status;
  }
  return true;
}
